import { Bell } from "lucide-react";
import SettingsSection from "./SettingsSection";

const notificationOptions = [
  {
    id: "integrationErrors",
    label: "Integration Errors",
    description: "Get notified when integrations fail"
  },
  {
    id: "workflowCompletions",
    label: "Workflow Completions",
    description: "Receive updates on workflow executions"
  },
  {
    id: "rateLimitWarnings",
    label: "Rate Limit Warnings",
    description: "Alert when approaching API limits"
  },
  {
    id: "securityAlerts",
    label: "Security Alerts",
    description: "Important security notifications"
  }
];

export default function NotificationsSection({ notifications, onChange }) {
  return (
    <SettingsSection
      icon={Bell}
      title="Notifications"
      description="Configure notification preferences"
    >
      <div className="space-y-4">
        {notificationOptions.map((option) => (
          <div
            key={option.id}
            className="flex items-center justify-between py-2"
          >
            <div>
              <p className="text-sm font-medium text-gray-900">
                {option.label}
              </p>
              <p className="text-sm text-gray-500">{option.description}</p>
            </div>
            <button
              onClick={() => onChange(option.id, !notifications[option.id])}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                notifications[option.id] ? "bg-blue-600" : "bg-gray-200"
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  notifications[option.id] ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        ))}
      </div>
    </SettingsSection>
  );
}
